/* Foamera — free gift picker (2026-07-16 draft)

   Any single cushion whose configured total is $250+ comes with a free gift;
   the customer picks Pillow Cover (default) or Table Runner at the bottom of
   Review & Confirm. Theme-side only — the app extension is untouched.

   How it rides along:
     - UI mounts as the LAST child of `[data-pcfg-review-section] .pcfg__step-review`.
       The app only rewrites the four data-pcfg-review-* slots' innerHTML, never
       this container, so the picker survives every reprice.
     - The choice reaches the order by wrapping PCfg.Cart.buildProperties.
       cfg-core resolves that function at call time (ATC click, confirm-checkbox
       prewarm, edit rehydrate), so one wrap covers every add path. Gift keys are
       not in _extras_json, so the server's price recompute ignores them.
     - Visibility re-evaluates via a MutationObserver on [data-pcfg-review-price],
       which mutates exactly once per completed reprice (300ms debounce).
   Below $250 the picker renders nothing and the wrapper adds nothing — the
   threshold is re-checked at click time, so hiding and pricing can't disagree. */
(function () {
  'use strict';

  var THRESHOLD = 250; /* store currency major units — same scale as calculatePrice().total */

  var GIFTS = {
    pillow: {
      /* cover only — we ship the COVER, not a filled pillow; never promise otherwise */
      name: 'Pillow Cover',
      dims: '18 × 18 in · zippered',
      listed: '$45',
      property: 'Pillow Cover (18×18 in, surprise colour)',
      img: 'https://cdn.shopify.com/s/files/1/0800/2381/4374/files/hf_20260716_100444_fcc35a59-e15b-4613-9a21-8be5895c4da9.png?v=1784196380'
    },
    runner: {
      name: 'Table Runner',
      dims: '14 × 72 in · finished edge',
      listed: '$40',
      property: 'Table Runner (14×72 in, surprise colour)',
      img: 'https://cdn.shopify.com/s/files/1/0800/2381/4374/files/hf_20260716_095647_2a5b07d8-2271-4738-84f0-b4045dca02f5.png?v=1784195903'
    }
  };

  var chosen = 'pillow'; /* the pillow is what ships when no choice is made */

  /* ---------- thumb çözünürlüğü (2026-08-27) ----------

     Sorun: iki hediye görseli CDN'den sabit `?width=120` ile isteniyordu, ama düzen
     thumb'ı her viewport'ta 120px render ETMİYOR. CLD15 önizlemesinde ölçtük
     (#foamera-gift .fmg-thumb, gerçek getBoundingClientRect genişlikleri):
        390px → 116px | 600px → 197px | 768px → 231px | 1024px → 334px
       1119px → 372px | 1280px → 119px | 1440px → 120px
     foamera-gift.css 601–1119px arasında thumb'ı kart genişliğine yayıyor
     (max-width:none + aspect-ratio 4/3), bu yüzden 120px kaynak 1024px'te 2.78×,
     1119px'te 3.10× büyütülüyordu. DPR 2 cihazda aynı bant 6.20×'e çıkıyor; hatta
     1440px'te bile (thumb tam 120px) DPR 2 → 2.00× ile bulanıktı.

     Çözüm: görseli küçültmek yerine CDN'den BİRDEN ÇOK boyut ilan edip seçimi
     tarayıcıya bırakıyoruz — Shopify CDN `?width=N` ile WebP/AVIF servis ediyor.
     Tarayıcı bu listeden yalnızca BİRİNİ indirir, hepsini değil.
     Adaylar ölçülen ihtiyaca göre seçildi (kaynak px = render px × DPR):
       120w → DPR1 masaüstü (>=1120px, thumb 120px)          ~2.8 KB/görsel
       240w → DPR2 masaüstü ve DPR2 mobil (390px, 232px)     ~6.9 KB
       360w → DPR3 mobil (348px) ve DPR1 1024px (334px)     ~13.4 KB
       480w → DPR2 768px (462px)                            ~24.9 KB
       720w → DPR2 1024–1119px (668–744px)                  ~65.5 KB
      1024w → DPR3 1024–1119px (1002–1115px)               ~143.0 KB
     1024w aynı zamanda TAVAN: Shopify Files'taki orijinaller 1024×1024 ve CDN
     bunun üstüne BÜYÜTMÜYOR (?width=1500 birebir aynı baytları döndürüyor).
     Tek karşılanamayan uç: DPR3 @1119px 1115px isterdi, 1024 veriyoruz (0.92×) —
     görünmez bir fark, daha büyük bir kaynak yüklemeden çözülemez. */
  var THUMB_WIDTHS = [120, 240, 360, 480, 720, 1024];

  /* sizes: >=1120px'te CSS thumb'ı clamp(96px,30%,120px) ile sabitliyor → 120px.
     Altındaki bantta ölçülen oran 29.7–33.2vw (390px'te 116, 1119px'te 372);
     34vw güvenli üst sınır — hep bir üst adayı seçtirir, altta bırakmaz.
     NOT: `auto` kullanmıyoruz; kutu eşik altındayken display:none olduğu için
     `auto` genişliği 0 ölçer ve en küçük adayı seçerdi. Media query'ler
     düzenden bağımsız çözüldüğü için gizliyken de doğru sonuç veriyor. */
  var THUMB_SIZES = '(min-width: 1120px) 120px, 34vw';

  /* Aynı CDN dosyasının farklı genişlikleri; baseUrl zaten ?v=... taşıdığı için & ile ekliyoruz. */
  function thumbSrcset(baseUrl) {
    var out = [];
    for (var i = 0; i < THUMB_WIDTHS.length; i++) {
      out.push(baseUrl + '&width=' + THUMB_WIDTHS[i] + ' ' + THUMB_WIDTHS[i] + 'w');
    }
    return out.join(', ');
  }

  function currentTotal(state) {
    try {
      var s = state || window.PCfg.Core.getState();
      return window.PCfg.Pricing.calculatePrice(s).total || 0;
    } catch (e) {
      return 0;
    }
  }

  /* ---------- properties ---------- */

  function wrapBuildProperties() {
    var cart = window.PCfg.Cart;
    if (cart._foameraGiftWrapped) return;
    var orig = cart.buildProperties;
    cart.buildProperties = function (state) {
      var p = orig.apply(this, arguments);
      try {
        if (currentTotal(state) >= THRESHOLD) {
          p['Gift'] = GIFTS[chosen].property;
          p['_foamera_gift'] = chosen;
        }
      } catch (e) { /* never break the add flow over a gift */ }
      return p;
    };
    cart._foameraGiftWrapped = true;
  }

  /* ---------- UI ---------- */

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  }

  function buildOption(key) {
    var g = GIFTS[key];
    var row = el('div', 'fmg-opt');
    row.setAttribute('role', 'radio');
    row.setAttribute('tabindex', '0');
    row.setAttribute('data-fmg-key', key);

    var radio = el('span', 'fmg-radio');
    radio.setAttribute('aria-hidden', 'true');

    var img = document.createElement('img');
    img.className = 'fmg-thumb';
    /* srcset/sizes'i src'den ÖNCE veriyoruz ki tarayıcı adayları görmeden
       fallback'i indirmeye başlamasın. */
    img.sizes = THUMB_SIZES;
    img.srcset = thumbSrcset(g.img);
    /* srcset desteklemeyen tarayıcı için tek boy: 480w tüm bantları DPR1'de karşılar. */
    img.src = g.img + '&width=480';
    img.alt = '';
    /* lazy DOĞRU: kutu $250 eşiği altında display:none, üstünde de sayfanın çok
       aşağısında. Ölçtük — kullanıcı oraya kaydırana kadar istek HİÇ gitmiyor. */
    img.loading = 'lazy';
    /* dekoratif thumb; decode ana iş parçacığını bloklamasın */
    img.decoding = 'async';
    /* kaynak 1024×1024, yani 1:1. (Eskiden 44×44 yazıyordu; hiçbir bantta
       render edilen boyut bu değildi.) Gerçek kutu boyutunu her bantta CSS
       belirliyor — height/aspect-ratio bu nitelikleri geçersiz kılıyor. */
    img.width = 120;
    img.height = 120;

    var body = el('div', 'fmg-body');
    body.appendChild(el('span', 'fmg-name', g.name));
    body.appendChild(el('span', 'fmg-dims', g.dims));

    var price = el('span', 'fmg-price');
    var was = el('s', 'fmg-was', g.listed);
    var now = el('strong', 'fmg-now', 'FREE');
    price.appendChild(was);
    price.appendChild(document.createTextNode(' '));
    price.appendChild(now);

    row.appendChild(radio);
    row.appendChild(img);
    row.appendChild(body);
    row.appendChild(price);

    function select() {
      chosen = key;
      syncSelection(row.parentNode);
    }
    row.addEventListener('click', select);
    row.addEventListener('keydown', function (ev) {
      if (ev.key === ' ' || ev.key === 'Enter' || ev.keyCode === 32 || ev.keyCode === 13) {
        ev.preventDefault();
        select();
      }
    });
    return row;
  }

  function syncSelection(group) {
    if (!group) return;
    var rows = group.querySelectorAll('.fmg-opt');
    for (var i = 0; i < rows.length; i++) {
      var on = rows[i].getAttribute('data-fmg-key') === chosen;
      rows[i].className = on ? 'fmg-opt fmg-opt--active' : 'fmg-opt';
      rows[i].setAttribute('aria-checked', on ? 'true' : 'false');
    }
  }

  function buildPicker() {
    var box = el('div', '');
    box.id = 'foamera-gift';
    box.style.display = 'none'; /* evaluate() reveals it — no flash below threshold */

    /* Short, value-led header — "free gift" said ONCE, worth stated up front,
       threshold cut to a fragment (was: three lines each repeating "free"). */
    box.appendChild(el('span', 'fmg-eyebrow', 'Free gift · worth $45'));
    box.appendChild(el('h4', 'fmg-title', 'Choose your gift'));
    box.appendChild(el('p', 'fmg-sub', 'Over $250 · ships in the same box.'));

    var group = el('div', 'fmg-group');
    group.setAttribute('role', 'radiogroup');
    group.setAttribute('aria-label', 'Choose your free gift');
    group.appendChild(buildOption('pillow'));
    group.appendChild(buildOption('runner'));
    box.appendChild(group);

    /* "Both are listed in our shop at the prices shown" removed — verified false:
       storefront search has no Table Runner product. Never claim what we don't list. */
    box.appendChild(el('p', 'fmg-note',
      'Colour & pattern are a surprise — no two are alike.'));

    syncSelection(group);
    return box;
  }

  function evaluate() {
    var box = document.getElementById('foamera-gift');
    if (box) box.style.display = currentTotal() >= THRESHOLD ? '' : 'none';
  }

  function observePrice() {
    var node = document.querySelector('[data-pcfg-review-price]');
    if (!node || !window.MutationObserver) return;
    var mo = new MutationObserver(evaluate);
    mo.observe(node, { childList: true, characterData: true, subtree: true });
  }

  function mount() {
    if (document.getElementById('foamera-gift')) { evaluate(); return; }
    var host = document.querySelector('[data-pcfg-review-section] .pcfg__step-review');
    if (!host) return;
    host.appendChild(buildPicker());
    evaluate();
    observePrice();
  }

  /* ---------- boot ---------- */

  function ready() {
    return window.PCfg && window.PCfg.Core && window.PCfg.Pricing &&
      window.PCfg.Cart && window.PCfg.Cart.buildProperties &&
      document.querySelector('[data-pcfg-review-section] .pcfg__step-review');
  }

  function boot() {
    if (!document.getElementById('pcfg-root')) return; /* not a configurator product */
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (ready()) {
        clearInterval(iv);
        wrapBuildProperties();
        mount();
      } else if (tries > 40) { /* ~10s — configurator never became ready */
        clearInterval(iv);
      }
    }, 250);
  }

  /* theme editor re-renders replace the section DOM — remount on fresh nodes */
  document.addEventListener('shopify:section:load', function () {
    setTimeout(boot, 50);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
